import { computed, effect, Injectable, signal } from '@angular/core';
import { LocalizeLanguage } from './localize-language';
import { LocalizationLanguages } from './localization-languages';
import { SystemConfigService } from '@app-common/services/system-config.service';

@Injectable({
    providedIn: 'root'
})
export class FormLocalizationService
{
    /** Dynamic languages derived from system config, with hardcoded fallback */
    languages = computed<LocalizeLanguage[]>(() => {
        const config = this.systemConfigService.config();
        if (config?.supportedLanguages?.length) {
            return config.supportedLanguages.map(l => ({
                name: l.name,
                value: l.code
            }));
        }
        return LocalizationLanguages;
    });

    localizationLanguage = signal<LocalizeLanguage>(LocalizationLanguages[0]);

    constructor(private systemConfigService: SystemConfigService)
    {
        // When languages update from backend, reset active language to first
        effect(() => {
            const langs = this.languages();
            if (langs.length > 0) {
                const current = this.localizationLanguage();
                // Only reset if the current language is no longer in the list
                const stillValid = langs.some(l => l.value === current.value);
                if (!stillValid) {
                    this.localizationLanguage.set(langs[0]);
                }
            }
        });
    }
}
